// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'
import 'vue-material/dist/theme/black-green-light.css'
import "vue-swatches/dist/vue-swatches.min.css"
import store from './store'
// https://fullcalendar.io/docs/
import "fullcalendar-scheduler";
import "fullcalendar/dist/fullcalendar.min.css";
import "fullcalendar-scheduler/dist/scheduler.min.css";

require('../node_modules/jquery-ui-bundle/jquery-ui.min.js');

// window.jQuery = window.$ = require('jquery')

Vue.config.productionTip = false;

Vue.use(VueMaterial);

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  // },
  // update: function (el) {
  //   Vue.nextTick(function() {
  //     el.focus();
  //   })
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js